<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>System</b>
    </sui-card-content>
    <sui-card-content>
      <sui-button basic icon="question circle" label-position="left" color="grey" size="small" v-if="!healthStatus && !isReady">No info</sui-button>
      <p v-if="!healthStatus && isReady">
        Please, update D2C&nbsp;Health&nbsp;Checker
      </p>
      <sui-button basic :icon="healthStatus.docker.icon" label-position="left" :color="healthStatus.docker.color" size="small" v-if="healthStatus">Docker</sui-button>
      <sui-button basic :icon="healthStatus.weave.icon" label-position="left" :color="healthStatus.weave.color" size="small" @click="$modals.log.open({target: 'weave', id: host.id})" v-if="healthStatus">Weave</sui-button>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button :disabled="isDisabled" @click="updateUtils()" data-goal="HOST_PAGE_UPDATE_UTILS">Update</sui-button>
      <sui-dropdown class="icon dropdown" :class="{disabled: isDisabled}" button icon="dropdown">
        <sui-dropdown-menu>
          <sui-dropdown-item v-for="systemUtil in systemUtils" :key="systemUtil.value" @click.stop="systemUtil.checked = !systemUtil.checked">
            <sui-checkbox :label="systemUtil.text" v-model="systemUtil.checked" @click.stop />
          </sui-dropdown-item>
          <sui-dropdown-header>
            <sui-button color="blue" size="mini" fluid :disabled="!checkedSystemUtils.length" @click="updateSelectedUtils()" data-goal="HOST_PAGE_UPDATE_UTILS">Update</sui-button>
          </sui-dropdown-header>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'HostHealthCard',
    props: {
      host: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        systemUtils: [
          {value: 'docker', text: 'Docker', checked: false},
          {value: 'weave', text: 'Weave', checked: false},
          {value: 'ping', text: 'D2C Health Checker', checked: false},
          {value: 'telegraf', text: 'Telegraf', checked: false},
          {value: 'lsyncd', text: 'Lsyncd', checked: false},
        ],
      }
    },
    computed: {
      ...mapGetters(['actionsById']),
      actions() {
        return this.actionsById[this.host.id]
      },
      isCreated() {
        return this.host._isCreated
      },
      inProgress() {
        return this.host._inProgress
      },
      isReady() {
        return this.host._isOnline && this.host.deployable
      },
      isDisabled() {
        return !this.isCreated || this.inProgress || !this.actions.hostUpdate
      },
      healthStatus() {
        return this.host.healthStatus && {
          docker: this.host.healthStatus.dockerOK ? {icon: 'check circle', color: 'green'} : {icon: 'exclamation circle', color: 'red'},
          weave: this.host.healthStatus.weaveOK ? {icon: 'check circle', color: 'green'} : {icon: 'exclamation circle', color: 'red'},
        }
      },
      checkedSystemUtils() {
        return this.systemUtils.filter(util => util.checked).map(util => util.value)
      },
    },
    methods: {
      updateUtils() {
        return this.$modals.confirm.open({
          text: 'You are going to update all D2C system utils.',
          callback: () => {
            this.host.setup().catch(error => {
              this.$emit('error', error.message)
            })
          },
        })
      },
      updateSelectedUtils() {
        this.host.setup(this.checkedSystemUtils).catch(error => {
          this.$emit('error', error.message)
        })
      },
    },
  }
</script>
